import React, { useState } from 'react';

function SearchBox({ onSearch, loading }) {
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(query);
  };

  const handleClear = () => {
    setQuery('');
  };

  return (
    <div className="search-box">
      <h3>🔍 Search Real Estate Projects</h3>
      <p>Search through analyzed projects using natural language queries</p>
      
      <form onSubmit={handleSubmit} className="search-form">
        <div className="search-input-container">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="e.g., 'luxury villas in Dubai', 'projects with swimming pool', 'affordable apartments'"
            className="search-input"
            disabled={loading}
          />
          {query && (
            <button
              type="button"
              onClick={handleClear}
              className="clear-button"
              disabled={loading}
            >
              ✕
            </button>
          )}
        </div>
        
        <div className="search-actions">
          <button
            type="submit"
            disabled={loading || !query.trim()}
            className="search-button"
          >
            {loading ? (
              <>
                <span className="loading-spinner small"></span>
                Searching...
              </>
            ) : (
              <>
                🔍 Search Projects
              </>
            )}
          </button>
        </div>
      </form>
      
      <div className="search-tips">
        <h4>💡 Search Tips:</h4>
        <ul>
          <li>Use natural language: "projects near beach" or "villas with garden"</li>
          <li>Search by location: "Dubai Marina" or "Downtown"</li>
          <li>Search by facilities: "gym", "pool", "parking"</li>
          <li>Search by type: "apartment", "villa", "townhouse"</li>
        </ul>
      </div>
    </div>
  );
}

export default SearchBox;
